<template>
	<page enable-flex>
		<view-list ref="view" work-type="11" :search="{scan: true}">
			<template #default="{data, index}">
				<view-list-card :key="index" :data="data">
					<template #tag>
						<c-state dict="LEVEL_TYPE" :value="data.level_type" type="hollow"></c-state>
					</template>

					<template #name>
						{{[data.brand_name, data.model_name, data.color_name, data.memory_name].filter(item => item).join(' ')}}
					</template>

					<template #state>
						<c-state dict="ABNORMAL_PRODUCT_STATE" :value="data.handle_state" type="state"></c-state>
					</template>

					<template #default>
						<c-field label="下架异常渠道">{{data.abnormal_channel_names}}</c-field>
						<c-field label="背贴码">{{data.produce_unique_code}}</c-field>
						<c-field label="IMEI">{{data.produce_imei}}</c-field>
						<c-field label="创建时间">{{data.create_date}}</c-field>
					</template>
				</view-list-card>
			</template>
		</view-list>
	</page>
</template>

<script>
	export default {
		data() {
			return {
			}
		},
		
		methods: {
		}
	}
</script>

<style lang="stylus" scoped>
</style>